/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Filter_ContractsInputs */



/**
* | output |
* | --- |
* | "Contracts" |
*
* @param {Partner_Org_Filter_ContractsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_filter_contracts = /** @type {((inputs?: Partner_Org_Filter_ContractsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Filter_ContractsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verträge")
	return /** @type {LocalizedString} */ ("Contracts")
});